import { useState, useCallback } from 'react'
import { useNavigate } from '@tanstack/react-router'
import Box from '@/components/box'
import { SearchFiltersFormDesktop } from '@/features/accommodation/search/components/SearchFiltersForm'
import {
  type LocationSearchParams,
  useLocationSearchParams,
} from '@/features/accommodation/hooks/useLocatiomSearchParams'
import { cn } from '@/lib/utils'

interface HomeSearchFiltersProps {
  className?: string
}

export function HomeSearchFilters({ className }: HomeSearchFiltersProps) {
  const navigate = useNavigate()
  const { filters } = useLocationSearchParams()
  const [localFilters, setLocalFilters] = useState<LocationSearchParams>(filters)

  const updateLocalFilters = useCallback(
    (updates: Partial<LocationSearchParams>, commit = false) => {
      const newState = { ...localFilters, ...updates }
      setLocalFilters(newState)
      if (commit) {
        void navigate({
          to: '/ubytovani/hledat',
          search: newState,
        })
      }
    },
    [localFilters, navigate],
  )

  const commitFilters = useCallback(() => {
    void navigate({
      to: '/ubytovani/hledat',
      search: localFilters,
    })
  }, [localFilters, navigate])

  return (
    <Box className={cn('rounded-3xl py-6 lg:px-8', className)}>
      <SearchFiltersFormDesktop
        localFilters={localFilters}
        filters={filters}
        updateLocalFilters={updateLocalFilters}
        commitFilters={commitFilters}
      />
    </Box>
  )
}
